/**
 * create by xiahou
 */


export class Tool {
  constructor() { }
  public static osType() {
    let n = navigator.userAgent.toLocaleLowerCase();
    let reg1 = /android|mobile/;
    let reg2 = /iphone|ipad|ipod|ios/;
    if (reg2.test(n)) {
      return "ios";
    } else if (reg1.test(n)) {
      return "android"
    } else {
      return "pc";
    }
  }
  public static randomStr(len: number) {
    const arr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let ans = '';
    for (var i = len; i > 0; i--) {
      ans += arr[Math.floor(Math.random() * arr.length)];
    }
    return ans;
  }
  public static getUrlParam(name: string) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); // 匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; // 返回参数值
  }
}